<div class="sidebar-panel">

    <div id="scroll-area" [perfectScrollbar] class="navigation-hold" fxLayout="column">

        <div class="sidebar-hold">

            <!-- Logo -->
            <div class="branding">

                <img src="assets/images/logo-fise-big.png" alt="" class="app-logo">
                <span class="app-logo-text">FISE-CONSULTAS</span>

                <span style="margin: auto" *ngIf="layoutConf.sidebarStyle !== 'compact'"></span>

            </div>

            <!-- Informacion del Usuario -->
            <div class="app-user" *ngIf="authService.isAutenticado()">
                <div class="app-user-photo">
                    <img src="assets/images/user_face.jpg" class="mat-elevation-z1" alt="">
                </div>
                <span class="app-user-name mb-05">
                    <mat-icon class="icon-xs text-muted">lock</mat-icon>
                    {{authService.usuario.loginUsuario}}
                </span>

                <!-- Small buttons -->
                <div class="app-user-controls">

                    <button class="text-muted" mat-icon-button mat-xs-button [matMenuTriggerFor]="appUserMenu">
                        <mat-icon>settings</mat-icon>
                    </button>

                    <button class="text-muted" mat-icon-button mat-xs-button matTooltip="Email" routerLink="/inbox">
                        <mat-icon>email</mat-icon>
                    </button>

                    <button class="text-muted" mat-icon-button mat-xs-button matTooltip="Cerrar Session" (click)="authService.logout()">
                        <mat-icon>exit_to_app</mat-icon>
                    </button>

                    <mat-menu #appUserMenu="matMenu">
                        <button mat-menu-item (click)="authService.logout()">
                            <mat-icon>exit_to_app</mat-icon>
                            <span>Cerrar sesión</span>
                        </button>
                    </mat-menu>
                </div>
            </div>

        </div>

    </div>

</div>